var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenAiChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#6D94A7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_348179_17335)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.21 9.41998C14.73 13.72 18.12 17.11 22.42 17.63C18.12 18.15 14.73 21.54 14.21 25.84C13.69 21.55 10.3 18.16 6 17.63C10.3 17.11 13.69 13.72 14.21 9.41998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2805 7.59998C20.4605 9.06998 21.6205 10.23 23.0805 10.4C21.6105 10.58 20.4505 11.74 20.2805 13.2C20.1005 11.73 18.9405 10.57 17.4805 10.4C18.9505 10.22 20.1105 9.05998 20.2805 7.59998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5802 18.79C25.8602 21.11 27.6902 23.31 30.0002 23.59C27.6802 23.87 25.8602 26.08 25.5802 28.39C25.3002 26.07 23.4702 23.87 21.1602 23.59C23.4802 23.31 25.3002 21.1 25.5802 18.79Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_348179_17335"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenAiChat);
export default __webpack_public_path__ + "static/media/GenAIChat.0065f2154c4d6a1de14effe46680eb5c.svg";
export { ForwardRef as ReactComponent };